module.exports = __webpack_public_path__ + "img/banner-2.d027690d.png";